import * as qs from 'qs';

export default (queryString: string) => qs.parse(queryString, {ignoreQueryPrefix: true});



// WEBPACK FOOTER //
// ./src/utils/parseQueryString.ts